import React from "react";
import { Helmet } from "react-helmet";
import Header from "./Header";
import Footer from "./Footer";

const Layout = ({ title, description, keywords, canonical, children }) => {
  const agencySchema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "@id": "https://cr8tiv.com/#organization",
        "name": "Cr8tiv Agency",
        "url": "https://cr8tiv.com",
        "logo": "https://cr8tiv.com/assets/cr8tiv-logo.svg",
        "sameAs": [
          "https://instagram.com/cr8tiv.agency",
          "https://tiktok.com/@cr8tiv.agency",
          "https://x.com/cr8tiv",
          "https://www.linkedin.com/company/cr8tiv-agency"
        ],
        "contactPoint": {
          "@type": "ContactPoint",
          "telephone": "+61-449899969",
          "contactType": "Customer Service",
          "areaServed": "AU"
        }
      },
      {
        "@type": "WebSite",
        "@id": "https://cr8tiv.com/#website",
        "url": "https://cr8tiv.com",
        "name": "Cr8tiv Agency",
        "publisher": {
          "@id": "https://cr8tiv.com/#organization"
        }
      }
    ]
  };

  return (
    <div>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        <link rel="canonical" href={canonical} />
        
        {/* Favicons */}
        <link rel="icon" href="/favicon.ico" />
        <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
        <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
        <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
        <link rel="manifest" href="/site.webmanifest" />
        
        {/* Theme Color */}
        <meta name="theme-color" content="#ffffff" />
        <meta name="msapplication-TileColor" content="#da532c" />

        {/* Unified Agency Schema */}
        <script type="application/ld+json">
          {JSON.stringify(agencySchema)}
        </script>
      </Helmet>

      <Header />
      <main>{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;